import { Button, FileUpload, FormField, Modal, Table } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useState } from 'react';
import { addNotification, buildBreadcrumbItems, fileToBase64, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import Favorites from '../../../../../components/extras/Favorites';
import MPModal from '../../../../../components/MPModal';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';

const pageSize = 20;

export const AdminProcessesPACPage = () => {

    const { data, menu, parameters } = useGlobalState();

    const [pac, setPac] = useState<any>();




    const [month, setMonth] = useState("");



    const [pacUniverse, setPacUniverse] = useState<any[]>();

    const [pacCharges, setPacCharges] = React.useState<File[]>([]);
    const [pacDate, setPacDate] = React.useState('');

    const handleUniverseLoadChange = async (files: File[]) => {
        try {
            // Use Promise.all to concurrently convert all files to Base64
            const base64Results = await Promise.all(files.map(fileToBase64));

            // Map the results back to an array of objects that include the Base64 data hjjhg 
            const attachmentsWithBase64 = base64Results.map(result => ({
                name: result.file.name,
                content: result.base64,
                size: result.file.size,
            }));
            console.log(attachmentsWithBase64[0]);
            handlePACUploadUniverse(attachmentsWithBase64[0]);


        } catch (error) {
            console.error('Error reading files:', error);
        }
    };

    const handlePACUpdateUniverse = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/pac/universe.update',
                    'JWT': getCookie("JWT"),
                },

                body: JSON.stringify({ pacs: pacUniverse }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            if (data.code == 0) {
                setPacUniverse(undefined);
                addNotification(data.status, "success", setData)
            } else {
                addNotification(data.status, "error", setData)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }
    const handlePACUploadUniverse = async (f: any) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/pac/universe',
                    'JWT': getCookie("JWT"),
                },

                body: JSON.stringify(f),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            if (data.code == 0) {
                setPacUniverse(data.pacs);
                addNotification(data.status, "success", setData)
            } else {
                addNotification(data.status, "error", setData)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }

    return (
        <CustomAppLayout
            toolsHide
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="m">

                        <Header
                            actions={<Favorites />}
                            description="Pago automático mediando cuenta corriente bancaria"
                        >PAC</Header>

                        <SpaceBetween direction="vertical" size="xs">
                            <FormField
                                label="Universo de mandatos"
                                description="Description"
                            >
                                <FileUpload

                                    onChange={({ detail }) => {
                                        const newFiles = detail.value.slice(0, 3);
                                        handleUniverseLoadChange(newFiles);
                                    }}
                                    accept='.txt'
                                    value={[]}
                                    i18nStrings={{
                                        uploadButtonText: e =>
                                            "Seleccionar archivo",
                                        dropzoneText: e =>
                                            "Arrastre archivo para cargar",
                                        removeFileAriaLabel: e =>
                                            `Eliminar archivo ${e + 1}`,
                                        limitShowFewer: "Show fewer files",
                                        limitShowMore: "Show more files",
                                        errorIconAriaLabel: "Error",
                                        warningIconAriaLabel: "Warning"
                                    }}
                                    showFileLastModified
                                    showFileSize
                                    showFileThumbnail
                                    tokenLimit={1}
                                />
                            </FormField>
                            <FormField
                                label="Cargar rendición"
                                description="Description"
                            >
                                <FileUpload
                                    onChange={({ detail }) => setPacCharges(detail.value)}
                                    value={pacCharges}
                                    accept='.txt'
                                    i18nStrings={{
                                        uploadButtonText: e =>
                                            "Seleccionar archivo",
                                        dropzoneText: e =>
                                            "Arrastre archivo para cargar",
                                        removeFileAriaLabel: e =>
                                            `Eliminar archivo ${e + 1}`,
                                        limitShowFewer: "Show fewer files",
                                        limitShowMore: "Show more files",
                                        errorIconAriaLabel: "Error",
                                        warningIconAriaLabel: "Warning"
                                    }}
                                    showFileLastModified
                                    showFileSize
                                    showFileThumbnail
                                    tokenLimit={1}
                                />
                            </FormField>
                            <FormField
                                label="Generar cobranza"
                                description="Description"
                            >
                                <div style={{ width: 130 }}>

                                    <MPModal
                                        width={120}
                                        today prevMonth nextMonth
                                        end={new Date()}
                                        date={`${parameters.period}`}
                                        onConfirm={(date) => {
                                            setPacDate(date.period);
                                        }}
                                    />
                                </div>

                            </FormField>

                        </SpaceBetween>

                    </SpaceBetween>



                    <Modal visible={!!pacUniverse} header={
                        <span>
                            Detalle de universo de mandatos
                        </span>
                    } size="medium" footer={
                        <Box>
                            <Box float='left'><Button variant="link" onClick={() => setPacUniverse(undefined)}>Cerrar</Button></Box>
                            <Box float='right'><Button variant='primary' onClick={() => handlePACUpdateUniverse()}>Actualizar</Button></Box>
                        </Box>
                    } onDismiss={() => setPacUniverse(undefined)}>
                        {pacUniverse && pacUniverse.length > 0 && (
                            <Table
                                columnDefinitions={[
                                    {
                                        id: "idUser",
                                        cell: (item) => <FormField label={item?.idUser}>{item.RUT}</FormField>,
                                        header: "ID Usuario"
                                    },
                                    {
                                        id: "displayName",
                                        cell: (item) => item.displayName !== "" ? item.displayName : "RUT no existe",
                                        header: "Nombre"

                                    },
                                    {
                                        id: "bank",
                                        cell: (item) => item.bank,
                                        header: "Banco"

                                    }
                                ]}
                                items={pacUniverse}
                            />
                        )}
                    </Modal>


                </>
            }
        />
    );
};
